import moment from 'moment';
import { ConfigService } from '../services/config.service';

export function filterDateComparator(filterDate, cellValue: string) {
  if (!cellValue) {
    return -2;
  }
  const cellDate = moment(cellValue, ConfigService.dates.shortDateTimeFormat)
    .startOf('day')
    .toDate();

  if (cellDate < filterDate) {
    return -1;
  }
  if (cellDate > filterDate) {
    return 1;
  }

  return 0;
}
